import React from 'react'
import MyListBlock from '../../../../UI/list/MyListBlock'
import { useState } from 'react'
import { useEffect } from 'react'
import SupplierContactButton from './form/SupplierContactButton'

const SupplierContactItem = ({ supplierContact, index }) => {

    const [list, setList] = useState([])

    useEffect(() => {
        setListItems()
    }, [supplierContact])

    const setListItems = () => {
        const listTemp = []

        listTemp.push({
            name: 'Тип',
            value: supplierContact && supplierContact.type ? supplierContact.type.name : ''
        })
        listTemp.push({
            name: 'Імʼя',
            value: supplierContact.name
        })
        listTemp.push({
            name: 'Телефон',
            value: supplierContact.phone
        })
        listTemp.push({
            name: 'Email',
            value: supplierContact.email
        })
        listTemp.push({
            name: 'Коментар',
            value: supplierContact.comment
        })

        setList(listTemp)
    }
    
  return (
    <div className='supplyBillItem__one'>
        <MyListBlock
            className={'supplyOrderView__topBlock myListBlock__wrap'}
            text={
                <span>
                    {`Контакт №${index + 1}`}
                    <SupplierContactButton 
                        supplierId={supplierContact.supplierId}
                        supplierContact={supplierContact}
                    />
                </span>
            }
            list={list} 
        />
    </div>
  )
}

export default SupplierContactItem